




























































































import {Component, Prop, Watch, Mixins} from 'vue-property-decorator'
import TrackingRequest from '@/model/request/TrackingRequest'
import {MixinMember} from '@/components/mixins/MixinMember'
import {ItrackCollection} from '@/helpers'
import {$, ObjectCollection, Model, IResource, ID} from 'simpli-web-sdk'
import Motorista from '@/model/resource/Motorista'
import * as Helper from '@/helpers'
import TipoOcorrencia from '@/model/resource/TipoOcorrencia'

@Component
export default class FilterTracking extends Mixins(MixinMember) {
  @Prop({required: true}) value!: TrackingRequest

  allMotorista = ItrackCollection.allMotoristasOfReport

  async mounted() {
    await this.allMotorista.query()
    await this.value.allTipoOcorrencia.query()
    await this.value.allCentroDeCusto.query()
    await this.value.allTipoInsumo.query()

    const filterNaoDevolvida = this.value.allTipoOcorrencia.items.filter((item) => !item.ehDevolvida)
    const filterDevolvida = this.value.allTipoOcorrencia.items.filter((item) => Boolean(item.ehDevolvida))

    this.value.tipoOcorrenciaNaoDevolvidaCollection = Helper.collect(TipoOcorrencia, filterNaoDevolvida)
    this.value.tipoOcorrenciaDevolvidaCollection = Helper.collect(TipoOcorrencia, filterDevolvida)
  }

  get motoristaResource() {
    return this.allMotorista.get(this.value.idMotorista)
  }
  set motoristaResource(val: Motorista | null) {
    this.value.idMotorista = val && val.$id || null
  }

  @Watch('value.updateAutomatically')
  updateAutomaticallyEvent(val: boolean) {
    Helper.setUpdateAutomaticallyTracking(val)
  }

  @Watch('value.placaVeiculo')
  hideTooltip() {
    this.$tip.hideAll()
  }

  formatSigla() {
    if (this.value.sigla) {
      this.value.sigla = this.value.sigla.toUpperCase()
    }
  }
}
